import { Component, HostBinding, OnInit } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { HelpdeskService } from '../services/delavci/helpdesk.service';
import { MainService } from '../services/delavci/main.service';
import { LoginPartnerService } from '../services/partner/login-partner/login-partner.service';
import { HelpdeskProcesses } from '../models/HelpdeskProcesses';
import { MatTableDataSource } from '@angular/material/table';

import { get } from 'jquery';
import { Modules } from '../models/Modules';
import { Questions } from '../models/Questions';
import { Answers } from '../models/Answers';
import { MatTabChangeEvent } from '@angular/material/tabs';
import {AccordionModule} from 'primeng/accordion';


// interface FAQ {
//   question: string;
//   answers: string[];
//   expanded: boolean;
// }

// interface Process {
//   name: string;
//   faqs: FAQ[];
// }

// interface Module {
//   id: number;
//   name: string;
//   processes: Process[];
// }

@Component({
  selector: 'app-faq-tab',
  templateUrl: './faq-tab.component.html',
  styleUrls: ['./faq-tab.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate('200ms', style({ opacity: 1 }))]),
      transition(':leave', [animate('200ms', style({ opacity: 0 }))]),
    ]),
    trigger('expandCollapse', [
      state('open', style({
        height: '*', // Use '*' to retain the original height
        opacity: 1,
        visibility: 'visible'
      })),
      state('closed', style({
        height: '0px', // Collapse to 0 height
        opacity: 0,
        visibility: 'hidden'
      })),
      transition('open <=> closed', animate('300ms ease-in-out')) // Adjust time as needed
    ])
  ],
  
})
export class FaqTabComponent implements OnInit {
  @HostBinding('style.marginLeft.px') marginLeft = 0;

  public dataRow: Task;

  public selectedModule: Modules;
  public dataSourceModules = new MatTableDataSource<Modules>();
  public dataSourceProcesses = new MatTableDataSource<Modules>([]);
  public dataSourceQuestions = new MatTableDataSource<Questions>([]);
  public dataSourceAnswers = new MatTableDataSource<Answers>();
  public dataSourceHelpdeskProcesses: Array<HelpdeskProcesses>;
  public displayedColumnsModules: string[];
  public displayedColumnsProcesses: string[];
  public displayedColumnsQuestions: string[];
  public displayedColumnsAnswers: string[];
  public displayedColumnsHelpdeskProcesses: string[];
  public moduleSelectedBool = false;
  public processSelectedBool = false;
  public questionSelectedBool = false;
  public answerSelectedBool = false;
  public notesText;
  public processSelectedTemp: Modules;
  public textQuestions;
  public questionSelectedTemp: Questions;
  public anwserSelectedTemp: Answers;
  public textAnswer;
  public updateQuestion = false;
  public updateAnswer = false;
  public updateQuestionRowSelected: Questions;
  private updateAnswerRowSelected: Answers;


  constructor(private helpdeskService: HelpdeskService, private mainService: MainService, private loginPartnerService: LoginPartnerService) { }

  ngOnInit() {
    this.getModules();
    //this.getProcesses();
  }

  // getModules() {
  //   this.helpdeskService.getModules(this.mainService.currentUserValue, 519721).subscribe(
  //     (response: any) => {
  //       if (response.success && response.data && response.data.modules) {
  //         this.modules = response.data.modules.map((module: any) => ({
  //           id: module.id,
  //           name: module.nameSmall,
  //           processes: [] 
  //         }));
  //       } else {
  //         console.log('Error: Invalid response format');
  //       }
  //     },
  //     error => {
  //       console.log('Error fetching modules:', error);
  //     }
  //   );
  // }

  getModules() {
    this.helpdeskService.getModules(this.mainService.currentUserValue, 519721).subscribe(data => {
      this.dataSourceModules = new MatTableDataSource(data.data.modules);
    }, error => {
      console.log(error);
    });
  }

  //maloprodaja 2449

  onModuleSelected(row: Modules) {
    this.selectedModule = row;
    // Reset dataSourceQuestions and dataSourceAnswers when a module is selected
    this.dataSourceQuestions = new MatTableDataSource<Questions>([]);
    this.dataSourceAnswers = new MatTableDataSource<Answers>([]);
    this.helpdeskService.getProcesses(this.mainService.currentUserValue, row.id, null).subscribe(data => {
      // Assign new data to dataSourceProcesses
      this.dataSourceProcesses = new MatTableDataSource<Modules>(data.data.modules);
    }, error => {
      console.error(error);
    });
  }

  onProcessSelected(row: Modules) {
    this.processSelectedTemp = row;
    this.dataSourceAnswers = new MatTableDataSource<Answers>([]);
    this.helpdeskService.getQuestions(this.mainService.currentUserValue, row.id, null,1).subscribe(data => {
      this.dataSourceQuestions = new MatTableDataSource<Questions>(data.data.questions);
    }, error => {
      console.log(error);
    });
  }

  onQuestionSelected(row: Questions) {
    if (this.questionSelectedTemp && this.questionSelectedTemp.id === row.id) {
      this.questionSelectedTemp = null;
      this.dataSourceAnswers = new MatTableDataSource<Answers>([]);
    } else {
      this.questionSelectedTemp = row;
      this.helpdeskService.getAnswers(this.mainService.currentUserValue, row.id, null, 1).subscribe(data => {
        const filteredAnswers = data.data.answers.filter(answer => answer.id !== 25); // Assuming you still want to filter out certain answers
        this.dataSourceAnswers = new MatTableDataSource<Answers>(filteredAnswers);
      }, error => {
        console.log(error);
      });
    }
  }
  
  
  


  onTabSelected(event: MatTabChangeEvent) {
    // Extract the index from the event object
    const tabIndex = event.index;
    const selectedModule = this.dataSourceModules.data[tabIndex];
    if (selectedModule) {
      this.onModuleSelected(selectedModule);
    }
  }

  


}
